<template>
  <div>
    <v-container class="py-10" id="cloud">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <div class="subtitle" style="color:#0391af">Chancen</div>
          <h2>35. Angebot IT-Fortbildung nach Größe</h2>
          <p>
            Die Visualisierung ist nicht intuitiv. Mir fällt aber auf die
            Schnelle auch nichts besseres ein.
          </p>
          <v-btn icon aria-hidden="true">
            <v-icon>mdi-share-variant</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" aria-hidden="true">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="download('image/jpeg')">
                <v-list-item-content>
                  <v-list-item-title>JPEG herunterladen</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="download('image/svg+xml')">
                <v-list-item-content>
                  <v-list-item-title>SVG herunterladen</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            icon
            aria-hidden="true"
            :to="{
              name: 'comparison',
              query: { var: 'konkrete Herausforderungen' }
            }"
          >
            <v-icon>mdi-chart-line</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "A035",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "line"
        },
        title: {
          text:
            "Wir bieten unseren Mitarbeitern die Möglichkeit, an Schulungen/ Fortbildungen/ Trainings zur Anwendung von IT teilzunehmen."
        },
        xAxis: {
          categories: [
            "sehr klein",
            "",
            "",
            "",
            "mittelgroß",
            "",
            "",
            "",
            "groß"
          ],
          tickmarkPlacement: "on",
          title: {
            enabled: true,
            text: "Größe der Organisation"
          }
        },
        yAxis: {
          labels: {
            format: "{value}%"
          },
          title: {
            enabled: true,
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> <br/>',
          split: false
        },

        series: [
          {
            name: "Trifft überhaupt nicht zu",
            data: [56.6, 47.5, 41.7, 30.2, 25.3, 20.2, 15.3, 11.1, 7.6]
          },
          {
            name: "Trifft vollständig zu",
            data: [7.6, 10.3, 9.1, 14.5, 18.3, 16.1, 21.1, 21.9, 24.1]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
